module.exports = __webpack_public_path__ + "media/mypage/images/special/TIMES2020-582f65b7f75ca0b5f123f2dfe70b27c1.jpg";